import Relay from 'react-relay';
/**
*  Delete musicPlayer mutation
*/
export default class DeleteMusicPlayerMutation extends Relay.Mutation {
  /**
  *  Mutation
  */
  getMutation() {
    return Relay.QL`mutation Mutation{
      removeMusicPlayer
    }`;
  }
  /**
  *  Variables
  */
  getVariables() {
    return {
        musicPlayerId: this.props.musicPlayerId,
    };
  }
  /**
  *  Fat query
  */
  getFatQuery() {
    return Relay.QL`
      fragment on removeMusicPlayerPayload @relay(pattern: true){
        clientMutationId,
        viewer{
            id
        }
      }
    `;
  }

  /**
  *  Config
  */
  getConfigs() {
    return [{
        type: 'FIELDS_CHANGE',
        fieldIDs: {
          viewer: this.props.viewer.id,
        },
    }];
  }

  static fragments = {
    viewer: () => Relay.QL`
      fragment on Viewer {
          id
      }
    `,
  };
}



// WEBPACK FOOTER //
// ./src/mutations/Venue/DeleteMusicPlayerMutation.js